<template lang="pug">
  sui-card
    sui-dimmer-dimmable(
      @mouseenter.native="active = true",
      @mouseleave.native="active = false")
      sui-image(:src="team.logo.main.svg")
      sui-dimmer(
        blurring,
        inverted,
        :active="active")
        sui-header(size="large") {{ team.name }}
        router-link(
          :to="`/teams/${team.teamId}`",
          is="sui-button",
          basic,
          secondary) View Details
</template>

<script>
export default {
  name: 'TeamCard',
  props: {
    team: {
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },
};
</script>
